import React from 'react';

interface MatteProps {
  type: 'x' | 'y';
  proportion: number;
}
const Matte = ({ type, proportion }: MatteProps) => {
  const commonStyle = {
    background: 'black',
    zIndex: 1,
    position: 'absolute',
    ...(type === 'x'
      ? { top: 0, bottom: 0, width: `${proportion * 100}%` }
      : { left: 0, right: 0, height: `${proportion * 100}%` }),
  } as const;

  return (
    <>
      <div
        style={{
          ...commonStyle,
          [type === 'x' ? 'left' : 'top']: 0,
        }}
      />
      <div
        style={{
          ...commonStyle,
          [type === 'x' ? 'right' : 'bottom']: 0,
        }}
      />
    </>
  );
};

export default Matte;
